<script lang="ts" context="module">
	export enum PageType {
		ARTICLE = 'article',
		HOME = 'home',
		CATEGORY = 'category',
		WHATEVER = 'whatever'
	}

	export enum Mode {
		INIT,
		PAGE
	}
</script>

<script lang="ts">
	import { browser } from '$app/environment';

	import { afterUpdate } from 'svelte';

	export let mode: Mode = Mode.INIT;
	export let type: PageType = PageType.WHATEVER;
	export let parameters: Record<string, string> = {};
	export let disableAds: boolean = false;

	afterUpdate(() => {
		if (mode == Mode.PAGE) {
			if (browser && window instanceof Window) {
				window._hbdbrk = window._hbdbrk || [];
				const vars: Record<string, string | number | boolean> = {
					page_type: type,
					...parameters
				};
				if (disableAds) {
					vars.no_pub = true;
				}
				window._hbdbrk.push(['_vars', vars]);
			}
		}
	});
</script>

<svelte:head>
	{#if mode == Mode.INIT}
		<script
			src="https://www.flashb.id/universal/213f6e49-828c-5e7c-b5b2-3a8b27ecef1f.js"
			async
			data-cfasync="false"
		></script>
	{/if}
</svelte:head>
